import Embed from './embed';

class VideoEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'video',
      customTitle: this.title(value),
      iconName: 'play_arrow',
      iconClass: '',
      image: value.thumbnail,
      buttons: ['edit'],
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static title({
    author = '',
    title = '',
  }) {
    return `${[title, author].filter(Boolean).join(' / ')}`;
  }

  static html() {
    return '';
  }

  static value(domNode) {
    const data = domNode.dataset;
    const value = {
      title: data.embedTitle,
      author: data.embedAuthor,
      id: data.embedId,
      thumbnail: data.embedThumbnail,
      type: data.embedType,
    };

    return value;
  }

  static get TYPE() {
    return {
      EXTERNAL: 'external-video',
      INTERNAL: 'internal-video',
    };
  }
}

VideoEmbed.blotName = 'videoEmbed';
VideoEmbed.className = 'ql-video';
VideoEmbed.tagName = 'div';

export default VideoEmbed;
